import { css } from '@emotion/react'
import { ModalBody, Text, VFlow } from 'bold-ui'

export const TornarResponsavelModal = () => {
  return (
    <ModalBody style={styles.modalBody}>
      <VFlow vSpacing={0.5}>
        <Text fontWeight='bold'>Esta ação não poderá ser desfeita.</Text>
        <Text>
          Para o sistema, a responsabilidade está relacionada com a capacidade de prescrever um plano de cuidado,
          avaliar um problema ou condição e liberar o cidadão.
        </Text>
      </VFlow>
    </ModalBody>
  )
}

const styles = {
  modalBody: css`
    padding: 0;
  `,
}
